(() => {
  if (!window.fetch || !window.DOMParser) return;
  const body = document.body;
  const cartUrl = body.dataset.cartUrl;
  const drawer = () => document.getElementById('cu-cart-drawer');
  const regions = () => [...document.querySelectorAll('[data-cu-cart-region]')];
  const sectionIds = () => [...new Set(regions().map(region => region.dataset.section))];
  const notice = document.querySelector('[data-cu-cart-notice]');
  let busy = false;
  let noticeTimer;
  let locked = [];
  const say = (message, error = false) => {
    clearTimeout(noticeTimer);
    notice.textContent = message;
    notice.dataset.error = String(error);
    notice.hidden = !message;
    // Keep feedback inside the modal so it remains available to screen readers.
    (drawer()?.open ? drawer() : body).append(notice);
    if (message && !error) noticeTimer = setTimeout(() => { notice.hidden = true; }, 3500);
  };
  const lock = value => {
    busy = value;
    body.classList.toggle('cu-cart-busy', value);
    regions().forEach(region => region.setAttribute('aria-busy', String(value)));
    if (value) {
      locked = [...document.querySelectorAll('[data-cu-checkout], [data-cu-cart-step], [data-cu-cart-quantity], [data-cu-add-button], [data-cu-sticky-add]')].filter(control => !control.disabled);
      locked.forEach(control => { control.disabled = true; });
      document.querySelectorAll('.cu-express-cart,.cu-express-product').forEach(node => { node.inert = true; });
    } else {
      locked.forEach(control => { if (control.isConnected) control.disabled = false; });
      locked = [];
      document.querySelectorAll('.cu-express-cart,.cu-express-product').forEach(node => { node.inert = false; });
    }
  };
  const replaceSections = sections => {
    const parsed = regions().map(region => {
      const html = sections?.[region.dataset.section];
      if (typeof html !== 'string') throw new Error(body.dataset.cartError);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = [...doc.querySelectorAll('[data-cu-cart-region]')].find(node => node.dataset.section === region.dataset.section);
      if (!next) throw new Error(body.dataset.cartError);
      return {region, next};
    });
    // Validate all sections first: totals and line items must change together.
    parsed.forEach(({region, next}) => { region.innerHTML = next.innerHTML; });
    const state = document.querySelector('[data-cu-cart-state]');
    if (state) document.querySelectorAll('[data-cu-cart-count]').forEach(node => { node.textContent = state.dataset.count; });
  };
  const sync = async () => {
    const url = new URL(cartUrl, location.origin);
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, {headers:{Accept:'application/json'}, cache:'no-store'});
    if (!response.ok) throw new Error(body.dataset.cartError);
    replaceSections(await response.json());
  };
  const showDrawer = () => {
    if (drawer()?.showModal) { if (!drawer().open) drawer().showModal(); }
    else location.assign(cartUrl);
  };
  const mutate = async (url, payload) => {
    const response = await fetch(url, {method:'POST', body:payload, headers:payload instanceof FormData ? {Accept:'application/json'} : {Accept:'application/json','Content-Type':'application/json'}});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : body.dataset.cartError);
    try { replaceSections(data.sections); } catch (_) { await sync(); }
    return data;
  };
  const change = async (input, quantity, focusAction) => {
    if (busy || !Number.isSafeInteger(quantity) || quantity < 0) return;
    const regionId = input.closest('[data-cu-cart-region]').dataset.section;
    const key = input.closest('[data-cu-line]').dataset.key;
    lock(true);
    say(body.dataset.cartUpdating);
    try {
      await mutate(`${cartUrl}/change.js`, JSON.stringify({id:key, quantity, sections:sectionIds(), sections_url:cartUrl}));
      say(body.dataset.cartUpdated);
    } catch (error) {
      try { await sync(); } catch (_) { input.value = input.dataset.original; }
      say(error.message || body.dataset.cartError, true);
    } finally {
      lock(false);
      const region = regions().find(node => node.dataset.section === regionId);
      const line = [...(region?.querySelectorAll('[data-cu-line]') || [])].find(node => node.dataset.key === key);
      const target = focusAction ? line?.querySelector(`[data-cu-cart-step="${focusAction}"]`) : line?.querySelector('[data-cu-cart-quantity]');
      (target || region?.querySelector('[data-cu-checkout], .cu-empty a'))?.focus({preventScroll:true});
    }
  };
  document.addEventListener('click', e => {
    const sticky = e.target.closest('[data-cu-sticky-add]');
    if (sticky) {
      const form = document.getElementById(sticky.dataset.cuStickyAdd);
      if (!busy) form?.requestSubmit(form.querySelector('[data-cu-add-button]'));
    }
    const cartLink = e.target.closest('.cu-cart-link');
    if (cartLink && !body.classList.contains('cu-cart-page') && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault(); showDrawer();
    }
    const step = e.target.closest('[data-cu-cart-step]');
    if (step) {
      const input = step.closest('[data-cu-line]').querySelector('[data-cu-cart-quantity]');
      change(input, Math.max(0, Number(input.value) + Number(step.dataset.cuCartStep)), step.dataset.cuCartStep);
    }
    const remove = e.target.closest('[data-cu-remove]');
    if (remove && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault(); change(remove.closest('[data-cu-line]').querySelector('[data-cu-cart-quantity]'), 0);
    }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-cu-cart-quantity]')) {
      const input = e.target;
      if (!input.validity.valid || input.value === '') { input.reportValidity(); input.value = input.dataset.original; return; }
      if (input.value !== input.dataset.original) change(input, Number(input.value));
    }
    if (e.target.matches('[data-cu-variant]')) {
      const option = e.target.selectedOptions[0];
      const purchase = e.target.closest('[data-cu-purchase]');
      const compare = purchase.querySelector('[data-cu-compare]');
      compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;
      const sticky = purchase.closest('.cu-product-page')?.querySelector('[data-cu-sticky]');
      if (sticky) { sticky.querySelector('[data-cu-sticky-price]').textContent = option.dataset.price; sticky.querySelector('button').disabled = option.dataset.available !== 'true'; }
    }
  });
  document.addEventListener('submit', async e => {
    if (e.target.matches('[data-cu-cart-form]')) { if (busy) e.preventDefault(); return; }
    const form = e.target.closest('[data-cu-add]');
    if (!form || (e.submitter && !e.submitter.matches('[data-cu-add-button]'))) return;
    e.preventDefault();
    if (busy) return;
    const button = form.querySelector('[data-cu-add-button]');
    if (button.disabled) return;
    const error = form.querySelector('[data-cu-error]');
    const payload = new FormData(form);
    payload.set('sections', sectionIds().join(',')); payload.set('sections_url', cartUrl);
    const url = new URL(form.action); url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    lock(true); button.textContent = button.dataset.busy; error.textContent = '';
    try {
      await mutate(url, payload);
      showDrawer(); say(body.dataset.cartAdded);
    } catch (err) {
      // A failed response may follow a successful cart write. Reconcile before retrying.
      try { await sync(); } catch (_) {}
      error.textContent = `${err.message || body.dataset.cartError}`;
      say(error.textContent, true);
    } finally {
      lock(false);
      button.disabled = form.querySelector('[data-cu-variant]').selectedOptions[0].dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.sold : button.dataset.label;
    }
  });
  const initSticky = () => document.querySelectorAll('[data-cu-sticky]:not([data-ready])').forEach(bar => {
    const button = document.getElementById(bar.dataset.form)?.querySelector('[data-cu-add-button]');
    if (!button || !window.IntersectionObserver) return;
    bar.dataset.ready = 'true';
    new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting; }, {rootMargin:'-100px 0px 0px 0px'}).observe(button);
  });
  body.classList.add('cu-js');
  drawer()?.addEventListener('close', () => { body.append(notice); notice.hidden = true; });
  initSticky();
  document.addEventListener('shopify:section:load', initSticky);
  window.addEventListener('pageshow', e => { if (e.persisted) sync().catch(() => {}); });
})();
